import Render from '@Views/components/stripe-expiry-alert.html'
import { Vue, Component} from 'vue-property-decorator'

@Render
@Component({})
export class StripeExpiryAlert extends Vue {
}
